function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, React.createElement("path", {
  d: "M82.05 0H0v130.46h108.38v-104zm-.22 12.54l13.92 14H81.83zM9 121.46V9h63.83v26.54h26.55v85.92z"
}), React.createElement("path", {
  d: "M27.42 61.1h54.36v5.5H27.42zM27.42 79.04h54.36v5.5H27.42zM27.42 96.99h54.36v5.5H27.42z"
}));

function SvgIconDocument(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 109 131"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTA5IDEzMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Im04Mi4wNSAwaC04Mi4wNXYxMzAuNDZoMTA4LjM4di0xMDR6bS0uMjIgMTIuNTQgMTMuOTIgMTRoLTEzLjkyem0tNzIuODMgMTA4Ljkydi0xMTIuNDZoNjMuODN2MjYuNTRoMjYuNTV2ODUuOTJ6Ii8+PHBhdGggZD0ibTI3LjQyIDYxLjFoNTQuMzZ2NS41aC01NC4zNnoiLz48cGF0aCBkPSJtMjcuNDIgNzkuMDRoNTQuMzZ2NS41aC01NC4zNnoiLz48cGF0aCBkPSJtMjcuNDIgOTYuOTloNTQuMzZ2NS41aC01NC4zNnoiLz48L2c+PC9zdmc+Cg==";
export { SvgIconDocument as ReactComponent };